import { render } from "./AssessorSearchView.vue?vue&type=template&id=afa9d040"
import script from "./AssessorSearchView.vue?vue&type=script&lang=js"
export * from "./AssessorSearchView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__